import { render, staticRenderFns } from "./MasterSelectControl.vue?vue&type=template&id=23808a5c&"
import script from "./MasterSelectControl.vue?vue&type=script&lang=ts&"
export * from "./MasterSelectControl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports